import React from 'react';
import { FaTrophy, FaLayerGroup, FaProjectDiagram, FaRedoAlt } from 'react-icons/fa';
import logo from '../../assets/img/LogoTorneoFC.png';
import './HeroBanner.css';

const HeroBanner = ({ groupsCount, knockoutMatchesCount, winner, onResetClick }) => (
  <section className="hero-banner">
    <div className="hero-banner__main">
      <div className="hero-banner__logo-wrap">
        <img src={logo} alt="Logo del torneo" className="hero-banner__logo" />
      </div>
      <div className="hero-banner__content">
        <h1>Torneo de Fútbol FC 26</h1>
        <p>Gestiona grupos, cruces y campeón con una experiencia profesional.</p>
      </div>
      <button type="button" className="hero-banner__reset" onClick={onResetClick}>
        <FaRedoAlt /> <span>Reiniciar torneo</span>
      </button>
    </div>

    <div className="hero-banner__stats">
      <span className="hero-banner__stat">
        <FaLayerGroup className="hero-banner__stat-icon" />
        <strong>{groupsCount}</strong> grupos
      </span>
      <span className="hero-banner__stat">
        <FaProjectDiagram className="hero-banner__stat-icon" />
        <strong>{knockoutMatchesCount}</strong> cruces
      </span>
      <span className={`hero-banner__stat ${winner ? 'hero-banner__stat--winner' : ''}`.trim()}>
        <FaTrophy className="hero-banner__stat-icon" />
        {winner ? winner.name : 'Sin campeón'}
      </span>
    </div>
  </section>
);

export default HeroBanner;
